<template>
<div>
  <v-dialog v-model="showDialog" max-width="450px" style="z-index:600" persistent no-click-animation scrollable>
    <v-card min-height="75%" min-width="95%">
      <v-toolbar :elevation="2" color="#2F75B5" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>個別設定</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="onCloseClick" text><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-row no-gutters>
            <v-col :cols="6" class="pa-2">
              <span class="text-black-bold">機能ヘルプ</span>
            </v-col>
            <v-col :cols="6" class="px-2">
              <v-radio-group label="" v-model="rec.helpUseFlg" row>
                <dd-radio-button label="表示する" :value="true" />
                <dd-radio-button label="表示しない" :value="false" />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <!--
          <v-row no-gutters>
            <v-col :cols="6" class="pa-2">
              <span class="text-black-bold">よく使う機能</span>
            </v-col>
            <v-col :cols="6" class="px-2">
              <v-radio-group label="" v-model="rec.oftenMenuFlg" row>
                <dd-radio-button label="表示する" :value="true" />
                <dd-radio-button label="表示しない" :value="false" />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col :cols="6" class="pa-2">
              <span class="text-black-bold">社内向けのお知らせ</span>
            </v-col>
            <v-col :cols="6" class="px-2">
              <v-radio-group label="" v-model="rec.userNotificationFlg" row>
                <dd-radio-button label="表示する" :value="true" />
                <dd-radio-button label="表示しない" :value="false" />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col :cols="6" class="pa-2">
              <span class="text-black-bold">車両のお知らせ</span>
            </v-col>
            <v-col :cols="6" class="px-2">
              <v-radio-group label="" v-model="rec.sharyoNotificationFlg" row>
                <dd-radio-button label="表示する" :value="true" />
                <dd-radio-button label="表示しない" :value="false" />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col :cols="6" class="pa-2">
              <span class="text-black-bold">免許更新のお知らせ</span>
            </v-col>
            <v-col :cols="6" class="px-2">
              <v-radio-group label="" v-model="rec.menkyoNotificationFlg" row>
                <dd-radio-button label="表示する" :value="true" />
                <dd-radio-button label="表示しない" :value="false" />
              </v-radio-group>
            </v-col>
          </v-row>
          -->
          <v-divider></v-divider>
          <v-row no-gutters>
            <v-col :cols="6" class="pa-2">
              <span class="text-black-bold">入力欄優先度</span>
            </v-col>
            <v-col :cols="6" class="px-2">
              <v-radio-group label="" v-model="rec.defaultInputManualFlg" row>
                <dd-radio-button label="手入力" :value="true" />
                <dd-radio-button label="マスタ" :value="false" />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col :cols="6" class="pa-2">
              <span class="text-black-bold">使用する日報画面</span>
            </v-col>
            <v-col :cols="6" class="px-2">
              <v-radio-group label="" v-model="rec.useNippoEditTransition" row>
                <dd-radio-button label="かんたん" :value="1" />
                <dd-radio-button label="通常" :value="0" />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <dd-custom-button :elevation="2" class="mx-5" color="#2F75B5" :minWidth="100" @click="onCloseClick">閉じる</dd-custom-button >
        <v-spacer></v-spacer>
        <dd-custom-button :elevation="2" class="mx-5" color="#2F75B5" :minWidth="100" @click="onSaveClick">反映</dd-custom-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>
<script>
// DdComponents アルファベット順記述
import DdCustomButton from '@/components/DdCustomButton'
import DdRadioButton from '@/components/DdRadioButton'

// Rahmen Definition アルファベット順記述
import controls from '@/rahmen/controls'
import flowMixin from '@/mixins/flowMixins'
import modals from '@/ddv2.library/modals'

// vue Definition
import { mapGetters } from 'vuex'

// IndexedDB管理用
// import ClientDB from '@/rahmen/clientDB'
// import conf from '@/rahmen/conf'

export default {
  name: 'DdUserSettingsDialog',
  mixins: [flowMixin],

  // 参照コンポーネント定義
  components: {
    DdCustomButton,
    DdRadioButton
  },

  // プロパティ定義
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
    * 読取モード
    */
    readOnly: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    invalidMessage: '',
    rec: {
      helpUseFlg: false
    }
  }),

  created () {
  },

  mounted () {
    const dtl = controls.getInputTypeDetail(this.valueType)
    if (!dtl) { return }
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage, this.$el)
  },

  watch: {
    showDialog: function (n) {
      if (n === true) {
        this.initBindVariables()
      }
    }
  },

  /* **************************************************************************************************** *
   *
   * 算出プロパティ
   *
   * **************************************************************************************************** */
  computed: {
    // --------------------------------------------------------------------------------
    // Indexed DB データ
    // --------------------------------------------------------------------------------
    ...mapGetters({
      loginJininId: 'users/userId'
    })
  },
  /* **************************************************************************************************** *
   *
   * メソッド
   *
   * **************************************************************************************************** */
  methods: {
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: [],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            // ユーザ保存項目の復元
            resolve()
          })
        },
        requestApiPromise: self.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            resolve()
          })
        },
        settingLoadEffect: function () {
          return true
        }
      }
      this.initializeForRegister(option)
    },
    fetchData: function () {
      if ([undefined, null].includes(this.loginJininId)) return

      const self = this
      return new Promise((resolve, reject) => {
        self.HttpClient
          .get(`/api/v1/mstUserSettings/FindByMstJininId?id=${self.loginJininId}`)
          .then((data) => {
            console.log(data)
            if (data.payload) {
              self.rec = data.payload
            } else {
              var t = {
                id: -1,
                mstJininId: self.loginJininId,
                helpUseFlg: true,
                oftenMenuFlg: true,
                userNotificationFlg: true,
                systemNotificationFlg: true,
                sharyoNotificationFlg: true,
                menkyoNotificationFlg: true,
                defaultInputManualFlg: true,
                useNippoEditTransition: 1
              }
              self.rec = Object.assign({}, t)
            }
            resolve()
          })
          .catch((e) => {
            console.log('error', e)
            self.onCloseClick()
            this.Effects.loadComplete()
            reject(e)
          })
      })
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      this.fetchData()
    },
    // --------------------------------------------------------------------------------
    // 閉じるボタン押下
    // --------------------------------------------------------------------------------
    onCloseClick: function (e) {
      this.$emit('close', undefined)
    },
    // --------------------------------------------------------------------------------
    // 保存ボタン押下
    // --------------------------------------------------------------------------------
    onSaveClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.Effects.loadComplete()
            modals.showToast('設定を保存しました。<br>変更は次回ログインより反映されます。', null, 500, null, 'info')
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isNoMessageModeMethod: function () {
          return true
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      const self = this
      const f = self.HttpClient.post(`/api/v1/mstUserSettings/Update?id=${self.rec.id}`, self.rec)
      return f
    },
    registerValidate: function () {
      return true
    }
  }
}
</script>
<style scoped>
.text-black-bold {
    color: #1F2B38;
    font-weight: bold;
}
</style>
